module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#twitter",
      toString: function () {
        return this.url;
      }
    }